import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { setToken } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const session_id = match[1];
    api.post("/auth/google/session", { session_id })
      .then(({ data }) => {
        setToken(data.token, data.user);
        toast.success("Signed in");
        if (data.needs_phone) nav("/dashboard?needs_phone=1");
        else nav("/dashboard");
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        nav("/login");
      });
  }, [nav, setToken]);

  return <div className="min-h-screen bg-midnight-deep flex items-center justify-center text-white/60">Signing you in…</div>;
}
